import { TApplicationState } from '../../types/redux';

export function buildingHasLayoutsSelector(state: TApplicationState) {
  return state.newbuilding.hasLayouts;
}
